var _circle, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 14,
    r: 11.2,
    fill: "#DBDCFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9896 16.0003L17.9137 10.0762C18.0978 9.89209 18.332 9.80005 18.6165 9.80005C18.901 9.80005 19.1353 9.89209 19.3194 10.0762C19.5035 10.2603 19.5955 10.4945 19.5955 10.779C19.5955 11.0635 19.5035 11.2978 19.3194 11.4819L12.6924 18.1088C12.4916 18.3096 12.2573 18.41 11.9896 18.41C11.7218 18.41 11.4876 18.3096 11.2867 18.1088L8.67612 15.4982C8.49204 15.3141 8.4 15.0798 8.4 14.7954C8.4 14.5109 8.49204 14.2766 8.67612 14.0925C8.86021 13.9084 9.09449 13.8164 9.37898 13.8164C9.66347 13.8164 9.89776 13.9084 10.0818 14.0925L11.9896 16.0003Z",
    fill: "#7E52FF"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.8d403e504dc8fa66491c9c0a1d0d52d8.svg";
export { ForwardRef as ReactComponent };